import { getToken, setToken, removeToken } from '@/utils/auth'
import { login as loginApi, logout as logoutApi } from '@/api/user'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // 用户登录 - 使用后端和数据库校验
  login({ commit }, userInfo) {
    return loginApi({
      accountNum: userInfo.username,
      password: userInfo.password
    }).then(response => {
      // 后端返回 data: { token, role }，分别取出存储
      const { token, role } = response.data
      commit('SET_TOKEN', token)
      setToken(token)
      if (role) {
        commit('SET_ROLES', [role.toLowerCase()])
      }
    })
  },

  // login({ commit }, userInfo) {
  //   return loginApi({
  //     accountNum: userInfo.username,
  //     password: userInfo.password
  //   }).then(response => {
  //     const token = response.data
  //     commit('SET_TOKEN', token)
  //     setToken(token)
  //   })
  // },

  // 获取用户信息 - 模拟数据
  getInfo({ commit }) {
    return new Promise(resolve => {
      const data = {
        roles: ['admin'],
        name: 'Admin',
        avatar: ''
      }
      const { roles, name, avatar } = data
      commit('SET_ROLES', roles)
      commit('SET_NAME', name)
      commit('SET_AVATAR', avatar)
      resolve(data)
    })
  },

  // 用户登出 - 先调后端删除 Redis 中的 token（立即失效），再清理本地
  logout({ commit }) {
    return logoutApi().catch(() => {
      // 后端调用失败（如 token 已过期）也不阻塞本地登出
    }).finally(() => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
    })
  },

  // 移除 token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
